// extracted by mini-css-extract-plugin
export var discard = "_1n-4";
export var muiTooltipTooltip = "_1n-6";
export var notificationBar = "_1n-3";
export var notificationContainer = "_1n-2";
export var saveButtonHoverSlotWrapper = "_1n-5";
export var show = "_1n-1";
export var spacer = "_1n-0";